import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import DefaultInput from "../../inputs/defaultInput";
import DefaultButton from "../../buttons/defaultButton";
import {
  createSession,
  updateSession,
} from "../../../../services/workspace/session.service";
import { useDispatch } from "react-redux";
import {
  _addSession,
  _updateSession,
} from "../../../../store/slices/baseSetup.slice";
import DefaultDatePicker from "../../inputs/defaultDatePicker";
import moment from "moment";
import { dateFormat } from "../../../../utils/helper";
import toast from "react-hot-toast";

const SessionForm = ({ setShowForm = () => null, sessionData, setSessionData = () => null, onBoard = false, handleNext = () => null }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    session_start: Yup.string()
      .required("Session start date is required")
      .test("isValid", "Invalid date format, expected DD/MM/YYYY", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      ),
    session_end: Yup.string()
      .required("Session end date is required")
      .test("isValid", "Invalid date format, expected DD/MM/YYYY", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
      )
      .test(
        "isAfterStart",
        "Session end date must be later than session start date",
        function (value) {
          const { session_start } = this.parent;
          return moment(value, "YYYY-MM-DD").isAfter(
            moment(session_start, "YYYY-MM-DD")
          );
        }
      ),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    touched,
    setFieldValue,
    errors,
  } = useFormik({
    initialValues: {
      name: sessionData?.name || "",
      session_start: dateFormat(sessionData?.session_start) || "",
      session_end: dateFormat(sessionData?.session_end) || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsSubmitting(true);

      if (sessionData?.id) {
        updateSession(values, sessionData.uuid)
          .then((response) => {
            setSessionData();
            setShowForm(false);
            setIsSubmitting(false);
            toast.success("Session updated successfully!");
            dispatch(_updateSession(response));
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to update session!" + error.response.data?.message
            );
          });
      } else {
        createSession(values)
          .then((response) => {
            setSessionData();
            setShowForm(false);
            setIsSubmitting(false);
            toast.success("Session created successfully!");
            handleNext();
            dispatch(_addSession(response));
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to create session!" + error?.response?.data?.message
            );
          });
      }
    },
  });

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <div className="flex flex-col px-4">
        <DefaultInput
          error={touched.name && errors.name ? errors.name : ""}
          name="name"
          onChange={handleChange}
          value={values.name}
          placeholder={"Session Name..."}
          label={"Session Name"}
          required
        />
        <DefaultDatePicker
          error={
            touched.session_start && errors.session_start
              ? errors.session_start
              : ""
          }
          name="session_start"
          onChange={(data) => setFieldValue("session_start", data)}
          value={values.session_start}
          placeholder={"YYYY-MM-DD"}
          label={"Start Date"}
          required
        />
        <DefaultDatePicker
          error={
            touched.session_end && errors.session_end ? errors.session_end : ""
          }
          name="session_end"
          onChange={(data) => setFieldValue("session_end", data)}
          value={values.session_end}
          placeholder={"YYYY-MM-DD"}
          label={"End Date"}
          required
        />
      </div>
      {onBoard ?
        <div className="flex flex-row items-center justify-center gap-2 mt-4">
          <DefaultButton
            loading={isSubmitting}
            name="Submit"
            type="submit"
            minWidth={100}
          />
        </div> :
        <div className="flex flex-row gap-3 border-t border-gray-200 px-4 pt-2">
          <DefaultButton
            onClick={() => {
              setSessionData();
              setShowForm(false);
            }}
            name="Back"
            variant="outline"
          />
          <DefaultButton
            loading={isSubmitting}
            type="submit"
            name={`${sessionData?.id ? "Updat" : "Creat"}${isSubmitting ? "ing" : "e"
              }`}
            variant="primary"
          />
        </div>}
    </form>
  );
};

export default SessionForm;
